export default {
  categories: (state, getters) => (id) => {
    if (id) {
      const category = getters.category(id);
      if (category) {
        return category.categories;
      }
      return null;
    }
    return state.categories.categories;
  },
  category: (state) => (id) =>
    state.category.find(
      (category) =>
        [category._id, category.legacyId].includes(id) ||
        category.path.split("/")[2] === id
    ),
  allCategories: (state) => () => state.allCategories,
  entry: (state, getters) => (categoryId, entryId) => {
    const category = getters.category(categoryId);
    if (category) {
      return category.entries.find(
        (entry) =>
          [entry._id, entry.legacyId].includes(entryId) ||
          entry.path.split("/")[2] === entryId
      );
    }
    return null;
  },
  searchOptions: (state) => () => state.searchOptions.data,
  homeData: (state) => () => state.homeData,
  categoryTree: (state) => () => state.categoryTree,
  calendar: (state) => (url) => {
    const cal = state.calendars.find((calendar) => calendar.url === url);
    return cal ? cal.data : [];
  },
  mostCommonEntryLayout: (state) => () => state.mostCommonEntryLayout.layout,
  // documentType is either "entry" or "category"
  moveDocumentDestinations: (state) => (documentType) => {
    const docType = documentType === "entry" ? "Entry" : "Category";
    return state[`move${docType}Destinations`];
  },
  recentlyDeleted: (state) => () => state.recentlyDeleted,
  analytics: (state) => () => state.analytics,
  datadogAnalytics: (state) => () => state.datadogAnalytics,
  twitterFeed: (state) => (buttonId) => {
    const feed = state.twitterFeeds.find((f) => f.buttonId === buttonId);
    return feed ? feed.tweets : [];
  },
  allTwitterFeeds: (state) => () => state.twitterFeeds,
  siteSwitcherSites: (state) => () => state.siteSwitcherSites,
};
